// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Clients_carousel__aWEco"};